import { booleanParser, createArrayWithBracesParser, numberArrayParser, numberParser } from '../inboundParsers';
import { chipsBetPerPlayerParser } from './utils/chipsBetPerPlayerInboundUtils';
import { lastActionParser } from './utils/lastActionInboundUtils';
import { communityCardsWithIndexesParser, optionalSeatIndexParser, seatIndexesParser, seatIndexParser } from './utils/pokerInboundUtils';
export const BET_INBOUND_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'isMyTurn', parser: booleanParser },
        { name: 'isPlayerSittingOut', parser: booleanParser },
        { name: 'minimumBet', parser: numberParser },
        { name: 'betIncrement', parser: numberParser },
        { name: 'smallBlindSeatIndex', parser: optionalSeatIndexParser },
        { name: 'deadSmallBlindSeatIndex', parser: optionalSeatIndexParser },
        { name: 'bigBlindSeatIndexes', parser: seatIndexesParser },
        { name: 'actionSeatIndex', parser: seatIndexParser },
        { name: 'buttonSeatIndex', parser: seatIndexParser },
        { name: 'betRoundNumber', parser: numberParser },
        { name: 'betSequenceNumber', parser: numberParser },
        { name: 'potAmounts', parser: numberArrayParser },
        { name: 'betTotalAmountToCall', parser: numberParser },
        { name: 'isStartingNewBetLoop', parser: booleanParser },
        { name: 'chipsBetPerPlayer', parser: createArrayWithBracesParser(chipsBetPerPlayerParser) },
        { name: 'lastAction', parser: lastActionParser },
        { name: 'timeMs', parser: numberParser },
        { name: 'timerDelayMs', parser: numberParser },
        { name: 'playSound', parser: booleanParser },
        { name: 'myMaxBetAmount', parser: numberParser },
        { name: 'myTotalBetAmount', parser: numberParser },
        { name: 'newCommunityCards', parser: communityCardsWithIndexesParser },
        { name: 'newBetRoundNumber', parser: numberParser },
        { name: 'newBetSequenceNumber', parser: numberParser },
        { name: 'canRaiseIndicator', parser: booleanParser }
    ]
};
